import PhotoResult from './photo-result';
import PropTypes from 'prop-types';
import React from 'react';

class PhotoView extends React.Component {
  render() {
    let results = [];
    this.props.results.forEach((result, index) => {
      if((index > 0) && (index%4 === 0)){
        results.push(<div className="clearfix until-xs-block" key={'clearblock' + index} ></div>);
      }
      else if((index > 0) && (index%2 === 0)){
        results.push(<div className="clearfix visible-xs-block" key={'clearblock' + index} ></div>);
      }
      results.push(<PhotoResult listing={result} key={index} />);
    });
    return (
      <div className="container">
        <div className="row">
          <div className="item-grid-container">
            <ul className="item-grid " role="presentation">
              {results}
            </ul>
            <div className="clearfix">&nbsp;</div>
          </div>
        </div>
      </div>
    );
  }
}

PhotoView.propTypes = {
  results: PropTypes.array.isRequired
};

export default PhotoView;


// WEBPACK FOOTER //
// ./src/components/search/photo-view.jsx